"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormTableField = void 0;
const table_field_1 = require("../../../components/table-field/table-field");
const form_field_1 = require("./form-field");
exports.FormTableField = form_field_1.formFieldFactory(table_field_1.TableField);
//# sourceMappingURL=form-table-field.js.map